import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_61: FaireProductEntity = {
  token: "catalog_prod_prod-61",
  type: "product",
  name: "Ceramic Bud Vase - Organic Shape - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 100.82,
  msrpDollars: 252.05,
  sku: "JA0061",
  caseSize: 3,
  material: "Ceramic",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 499,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_stationery-writing"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
